var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86821 0.511596C6.70956 0.564158 7.53688 0.792956 8.26605 1.19799C9.87 2.08948 10.9379 3.80032 10.9972 5.57094C11.0457 7.02721 10.4611 8.43917 9.71791 9.71096C8.71261 11.4321 7.40097 12.9873 5.86498 14.3034C5.75819 14.3951 5.63846 14.49 5.49608 14.4992C5.30516 14.5116 5.1466 14.3704 5.01392 14.2395C3.75406 12.9966 2.5093 11.7186 1.55794 10.2459C0.748952 8.99467 0.155696 7.58478 0.0187075 6.11098C-0.0999437 4.83507 0.353088 3.53339 1.1707 2.52132C1.64639 1.93283 2.24827 1.4371 2.93645 1.09081C3.83281 0.641454 4.85968 0.448728 5.86821 0.511596ZM8.55189 5.64823C8.47962 4.02294 7.07306 2.75321 5.41734 2.81504C3.71415 2.87894 2.37879 4.227 2.44459 5.81725C2.51254 7.43637 3.92773 8.7164 5.57914 8.65147C7.28663 8.58345 8.62308 7.23333 8.55189 5.64823Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/locationPin.a40b5e7e1dc634bdee2bbed359a29b07.svg";
export { ForwardRef as ReactComponent };